import CollapseTab from "@/components/CollapseTab";
import splitTopicUrlnameAndFilterId from "@/utils/splitTopicUrlnameAndFilterId";
import { useRouter } from "next/router";
import { useCallback, useMemo, useRef } from "react";
import styles from "./index.module.less";

export default function TopicNav({ options = [], value = null, onChange }) {
  const router = useRouter();
  const { urlname: params } = router.query;
  const { urlname } = splitTopicUrlnameAndFilterId(params);

  const navRef = useRef(null);

  const onClick = useCallback(
    (evt, option) => {
      evt.preventDefault();
      onChange && onChange(option);
    },
    [onChange]
  );

  const list = useMemo(() => {
    return options?.map((item, index) => {
      const { img, label, value: optionValue } = item;
      return {
        img,
        name: label,
        active: optionValue === (value?.value || ""),
        value: optionValue,
        props: {
          href: `/topics/${urlname}-${optionValue}`,
          "data-gd-click": "button_click",
          // "data-gd-expose": "resource_loc_expose",
          "data-resource-id": optionValue,
          "data-button-name": label,
          "data-resource-title": label,
          "data-resource-type": "子主题",
        },
      };
    });
  }, [options, value, urlname]);
  return (
    <div className={styles.nav} ref={navRef}>
      {/* 用于埋点 */}
      <h1 className={styles.hidden} data-topic-subtitle>
        {options.find((option) => option.value === (value?.value || ""))?.label}
      </h1>

      <CollapseTab
        list={list}
        displayRow={2}
        itemClick={(e, item) => {
          onClick(item, e);
        }}
      ></CollapseTab>
    </div>
  );
}
